import { render, staticRenderFns } from "./vendor-project-details.vue?vue&type=template&id=656490fb&scoped=true&"
import script from "./vendor-project-details.vue?vue&type=script&lang=js&"
export * from "./vendor-project-details.vue?vue&type=script&lang=js&"
import style0 from "./vendor-project-details.vue?vue&type=style&index=0&id=656490fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656490fb",
  null
  
)

export default component.exports